import React from "react";
import {connect} from "react-redux";
import Agb from "../components/Agb";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class AgbContainer extends React.Component {
    render() {
        return (
            <div>
                <Agb />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgbContainer);


// WEBPACK FOOTER //
// ./src/container/AgbContainer.js